import React from 'react'
import ExportInProgress from './ExportInProgress'

const ExportFileContent = ({ isExportLoading }) => {

  return (
    <>
      {isExportLoading ?
        <ExportInProgress />
        : null
      }
    </>
  )
}
export default ExportFileContent